






import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';

/** Boolean类型数据显示 */
@Component({})
export default class BooleanDisplay extends Vue {
  @Prop() value: boolean;
  @Prop() text?: string[]; // 自定义属性值 example: ['对','错']

  get getText() {
    let text = this.value ? '是' : '否';
    if (this.text && this.text.length > 1) {
      text = this.value ? this.text[0] : this.text[1];
    }
    return text;
  }
}
